const translations = {
    title: 'User Details'
};

export default translations;
